import { Fragment, memo, useRef } from 'react'
import { useSelector } from 'react-redux'
import { tileEntityAllIdsSelector } from 'client/store/tileEntity'
import { currentPageSelector, totalEntityCountSelector } from 'client/store/paging'
import { CareTile } from 'client/components/Gallery/PreviewArea/CareTile'
import { currentPageInfoSelector, loadMoreCountSelector } from '~/client/store/paging/selectors'
import { DesignTileWrapper } from 'client/components/Gallery/PreviewArea/DesignTileWrapper'
import { getIsLoadMoreAvailable } from '~/client/store/config/selectors'
import { useColorSwatchResizeObserve } from '~/client/hooks/useColorSwatchResizeObserve'
import { THREE_DIFY_TILE_POSITIONS } from '~/client/components/Gallery/PreviewArea/constants'
import { shouldHideCareTileSelector } from '~/client/store/refinement/selectors'

const DesignTilesListComponent = () => {
  const resultCount = useSelector(totalEntityCountSelector)
  const tileEntityIds = useSelector(tileEntityAllIdsSelector)
  const currentPage = useSelector(currentPageSelector)
  const isLoadMoreAvailable = useSelector(getIsLoadMoreAvailable)
  const loadMoreCount = useSelector(loadMoreCountSelector)
  const shouldHideCareTile = useSelector(shouldHideCareTileSelector)
  const { pageSize } = useSelector(currentPageInfoSelector)
  const gridRef = useRef<HTMLDivElement>(null!)
  const maxColorSwatchesPerRow = useColorSwatchResizeObserve(gridRef)

  const isFirstPage = currentPage === 1

  const isFirstPageAndTemplatesExist = isFirstPage && resultCount > 0
  const shouldShowCareTile = isFirstPageAndTemplatesExist && !shouldHideCareTile && !(tileEntityIds.length < pageSize)

  const calculateCareTilePosition = (index: number): boolean => {
    if (!shouldShowCareTile) {
      return false
    }

    if (isLoadMoreAvailable) {
      return THREE_DIFY_TILE_POSITIONS.includes(index)
    }

    return (THREE_DIFY_TILE_POSITIONS.indexOf(index) > -1 && THREE_DIFY_TILE_POSITIONS.indexOf(index) < loadMoreCount) || tileEntityIds.length === index + 1
  }

  return (
    <>
      {tileEntityIds.map((entityId: string, index: number) => {
        const shouldPinCareTile = calculateCareTilePosition(index)

        const refValue = index === 0 ? gridRef : null

        return (
          <Fragment key={entityId}>
            <li className="design-tile-wrapper" data-testid="design-tile">
              <DesignTileWrapper entityId={entityId} maxColorSwatchesPerRow={maxColorSwatchesPerRow} refValue={refValue} />
            </li>
            {shouldPinCareTile && <CareTile />}
          </Fragment>
        )
      })}
    </>
  )
}

export const DesignTilesList = memo(DesignTilesListComponent)
